export const WAREHOUSE_FETCHED_ALL = 'warehouse.FETCH_ALL';
export const WAREHOUSE_FETCHED_LEASED = 'warehouse.FETCHED_LEASED';
export const WAREHOUSE_LEASED = 'warehouse.LEASED';
export const WAREHOUSE_UNLEASED =  'warehouse.UNLEASED';
